/**
 * HistoricoPanel — lista cronológica do histórico append-only (RF-M8-004,
 * RN-M8-001, US-04, US-08 §5). Cada entrada: campo, antes→depois, autor, data e
 * tipo (Correção / Conferência). Leitura universal (consulta/editor/admin).
 */

import { HistoricoEntry } from '../services/edicao-types';

/** Conferência tem `campo === null`; edição tem um campo alterado. */
function ehConferencia(e: HistoricoEntry): boolean {
  return e.campo === null;
}

function rotuloEvento(e: HistoricoEntry): string {
  return ehConferencia(e) ? 'Conferência' : 'Correção';
}

function formatarData(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString('pt-BR');
}

export function HistoricoPanel({
  entradas,
  carregando,
  erro,
}: {
  entradas: readonly HistoricoEntry[] | undefined;
  carregando: boolean;
  erro: boolean;
}): JSX.Element {
  if (carregando) {
    return <p className="muted">Carregando histórico…</p>;
  }
  if (erro) {
    return <p className="notice">Não foi possível carregar o histórico.</p>;
  }
  if (!entradas || entradas.length === 0) {
    return <p className="muted">Nenhuma edição ou conferência registrada.</p>;
  }
  return (
    <ul className="historico-list" data-testid="historico-list">
      {entradas.map((e, i) => (
        <li className="historico-item" key={`${e.timestamp}-${i}`}>
          <span className={`pill ${ehConferencia(e) ? 'pill-ok' : 'pill-muted'}`}>
            {rotuloEvento(e)}
          </span>
          {!ehConferencia(e) && (
            <span className="historico-diff">
              <strong>{e.campo}</strong>: {e.valorAnterior ?? '—'} → {e.valorNovo ?? '—'}
            </span>
          )}
          <span className="historico-meta muted">
            {e.usuarioId} · {formatarData(e.timestamp)}
          </span>
          {e.comentario && <span className="historico-comentario">“{e.comentario}”</span>}
        </li>
      ))}
    </ul>
  );
}
